import { useEffect, useState } from "react";
import styles from "./invalid_extension_modal.module.css";

import { cloneDeep } from "lodash";
import { useLocation } from "react-router-dom";
import { Dialog, TextField } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

export default function InvalidExtensionModal(props) {
  const { openData, close } = props;
  const [value, setValue] = useState("");

  return (
    <Dialog open={openData} onClose={close}>
      <div className={styles.modal_wrapper}>
        <div className={styles.modal_title}>{`Invalid file name or extension. Files must of of type *.zip.`}</div>
        <div className={styles.modal_body}>{openData}</div>
        <div className={styles.modal_button_wrapper}>
          <LoadingButton disabled={false} variant="contained" loading={false} onClick={close}>
            Okay
          </LoadingButton>
        </div>
      </div>
    </Dialog>
  );
}
